export default __webpack_public_path__ + "static/media/emptyCart.9bdd8040.png";